<template>
    <div id="home">
        <header>
            <div header-wrap>
                <div menu-item>
                    <img src="../assets/imgs/home/牛.png" />
                    <a href="/" class="logo">牛人搭档</a>
                </div>
                <div menu-item v-for="(cm,index) in curMenu" :key="index"
                    v-bind:class="{ 'menu-active': cm.code=='main'}">
                    <router-link :to="cm.defaultUrl">
                        {{cm.name}}
                    </router-link>
                </div>
            </div>
            <div header-user>
                <span header-user-type>{{curUser.DomainName}}</span>
                <span header-user-filter> | </span>
                <span header-user-type>{{curUser.RoleName}}</span>
                <span header-user-filter> | </span>
                <span header-user-name>{{curUser.UserName}}</span>
                <router-link to="/login">
                    <img header-user-img src="../assets/imgs/home/power.png" alt="">
                </router-link>
            </div>
        </header>
        <div container>
            <div container-item="left">
                <div container-item-header>
                    <div container-item-header-img>
                        <img v-if="curUser.AvatarUrl==null" src="../assets/imgs/home/head.png" alt="">
                        <img v-if="curUser.AvatarUrl!=null" :src="imgHost+curUser.AvatarUrl" alt="">
                    </div>
                    <div container-item-name>
                        <span>{{curUser.UserName}}</span>
                        <span name-block>{{curUser.WorkRoleName}}</span>
                    </div>
                    <!-- <div container-item-name="acc">
                        {{curUser.LoginId}}
                    </div> -->
                </div>
                <div container-item-menu>个人信息</div>
                <div container-user-info>
                    <table>
                        <tr>
                            <td>角色:</td>
                            <td>{{curUser.RoleName}}</td>
                        </tr>
                        <tr>
                            <td>登录账号:</td>
                            <td>{{curUser.LoginId}}</td>
                        </tr>
                        <tr>
                            <td>邮箱:</td>
                            <td>{{curUser.Email==''?'未知':curUser.Email}}</td>
                        </tr>
                        <tr>
                            <td>手机号码:</td>
                            <td>{{curUser.MobilePhone==''?'未知':curUser.MobilePhone}}</td>
                        </tr>

                        <tr>
                            <td>组别:</td>
                            <td>{{curUser.GroupName}}</td>
                        </tr>
                        <tr>
                            <td>上级姓名:</td>
                            <td>{{curUser.ParentName==''?'未知':curUser.ParentName}} </td>
                        </tr>



                    </table>
                </div>
            </div>
            <div container-item="right">
                <div container-item-das-main>
                    <div container-item-das="left">
                        <!-- <div das-title>拜访达成</div> -->
                        <!-- <div das-chart="1"></div> -->
                    </div>
                    <div container-item-das="right">
                        <div container-item-das-link><a href="https://dwniuren.mengniu.cn/" target="_blank"
                                style="color:#000; text-decoration: underline;">老版“牛人搭档”登录入口</a></div>
                        <!-- <div das-title>销量</div> -->
                        <!-- <div das-chart="2"></div> -->
                    </div>
                </div>
                <div container-item-info="bottom">
                    <div container-item-info-l1>
                        <div info-l1-left>
                            <div info-l1-left-wrap>
                                <div info-l1-left-l>
                                    <img src="../assets/imgs/home/mnlogo.png" alt=""
                                        style="width:100px;border-radius: 5px">
                                </div>
                                <div info-l1-left-r>
                                    <div das-title="info">系统消息</div>
                                    <div info-txt>2020年1月10日，“牛人搭档”升级版正式上线，感谢您的支持。</div>
                                </div>
                            </div>

                        </div>
                        <div info-l1-right>
                            <div info-l1-wrap>
                                <div das-title="info-sm">通知公告
                                    <span>
                                        <i class="fa fa-clock-o" aria-hidden="true"></i> 2020-01-10</span>
                                </div>
                                <div info-txt="">
                                    <a href="https://niuren.mengniu.cn/api/File/Downloads/8804" target="_blank">牛人搭档新版APP下载及操作说明</a>
                                    <a href="https://niuren.mengniu.cn/api/File/Downloads/8805" target="_blank">牛人搭档新版电脑Web端操作说明</a>
                                </div>  
                            </div>
                        </div>
                    </div>

                    <div container-item-info-l2>
                        <div info-l1-right>
                            <div info-l1-left-wrap>
                                <div info-l1-left-l>
                                    <img src="../assets/imgs/main/qrcode.jpg" alt=""
                                        style="width:100px;border-radius: 5px">
                                </div>
                                <div info-l1-left-r>
                                    <div das-title="info">APP下载</div>
                                    <div info-txt>
                                        APP下载可扫描左边二维码，也可通过浏览器http://ios.cxish.com/dw/进行下载。
                                        <div style="text-align: center;     font-weight: bold;">有事搜一搜 没事看一看！</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div info-l1-right>
                            <div info-l1-wrap>
                                <!-- <div info-l1-wrap="active"> -->
                                <!-- <div das-title="info-sm">新版牛人搭档上线啦！
                                    <span>
                                        <i class="fa fa-clock-o" aria-hidden="true"></i> 2019-09-01</span>
                                </div>
                                <div info-txt="">海外网6月10日电
                                    据美国全国广播公司（NBC）消息，当地时间6月9日，美国总统特朗普登上“空军一号”前往新加坡，预计周二（12日）在新加坡会见朝鲜最高领导人金正恩。
                                </div> -->
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div bottom-suge>品质20年 &nbsp;&nbsp;&nbsp;&nbsp;让世界看见</div>
    </div>
</template>

<script>
    import store from "../utils/storage";
    import { imgServerHost, getRoleOption } from "../api/api";

    export default {
        name: "Home",
        data() {
            return {
                curUser: store.getUserInfo(),
                curMenu: store.getCurMenu(),
                imgHost: imgServerHost(),
            };
        },
        mounted() {
            var ms = store.getMenus();
            if (ms.length === 0) this.$router.push({ path: "/login" });

            console.info(this.curMenu);

            getRoleOption(false).then(res => { });

        },

    };
</script>

<style scoped>
    @import "../assets/css/home.css";
</style>


// WEBPACK FOOTER //
// src/components/Home.vue